import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import componentes from './componentes'
import { RootState } from './rootState'
import { ActionTree, GetterTree, MutationTree } from 'vuex'
import { UsuarioManager } from './usuarioManager'
import { ConfigManager } from './configManager'
import http from '../http'
import { startIdle, stopIdle } from '../plugins/idleController'

export function installVue2Store() {
    Vue.use(Vuex)
}

function createRootState(): RootState {
    return {
        isLoading: true,
        isAuthenticated: false,
        isUpdated: true,
        isServerOut: false,

        unidadeId: parseInt(localStorage.unidadePadraoId) || 1,

        config: {} as ConfigManager,
        erros: [],
        usuario: {} as UsuarioManager,

        status: [],
        unidades: [],
        empresas: [],
        cidades: [],
        conselhos: [],
        estados: [],
        agendamentoTarefaConfiguracoes: ''
    }
}

const rootGetters: GetterTree<RootState, RootState> = {
    isInRole: (state) => (role) => {
        return state.usuario.regras != null && state.usuario.regras.includes(role);
    },
    isUser: (state) => (userId) => {
        return state.usuario.id == userId;
    } 
}

const rootActions: ActionTree<RootState, RootState> = {
    async init ({ dispatch }) {
        return await Promise.all([
            dispatch('restoreContext'),
            dispatch('getUser')
        ])
    },
    login({ commit }, credentials) {
        commit('SET_ISLOADING', true)
        commit('CLEAR_ERRO')
        return http.post('/api/auth/login', credentials)
            .then(res => {
                commit('SET_AUTH', res.data)
                commit('SET_ISLOADING', false)
                commit('idle/RESTART_TIME')                
            })
            .catch(err => {
                commit('SET_AUTH', {})
                commit('ADD_ERRO', err.data?.erro ?? err.message)
                commit('SET_ISLOADING', false)
            })
    },
    logout({ commit }) {
        commit('SET_ISLOADING', true)
        return http.post('/api/auth/logout')
            .then(() => {
                commit('SET_AUTH', {})
                commit('SET_ISLOADING', false)

                history.pushState(null, 'Login', '/');
            })
            .catch(err => {
                commit('SET_AUTH', {})
                commit('ADD_ERRO', err.response?.data?.erro ?? err.message)
                commit('SET_ISLOADING', false)
            })
    },
    async restoreContext({ commit }) {
        commit('SET_ISLOADING', true)
        await http.get('/api/auth/config')
            .then(res => {
                commit('SET_CONFIG', res.data)                              
            })
            .catch(err => {
                commit('SET_AUTH', {})
                commit('ADD_ERRO', "Não foi possível buscar as configurações!\n" + err.response.data.erro)
                return
            })
    },
    async getUser({ commit }){
        await http.get('/api/auth/context')
            .then(res => {
                commit('SET_AUTH', res.data)
                commit('SET_ISLOADING', false)
            })
            .catch(() => {
                commit('SET_AUTH', {})
                commit('SET_ISLOADING', false)
            })
    }
}

const rootMutations: MutationTree<RootState> = {
    SET_ISLOADING(state, isLoading) {
        state.isLoading = isLoading
    },
    SET_ISUPDATED(state, isUpdated) {
        state.isUpdated = isUpdated
    },
    SET_ISSERVEROUT(state, isServerOut) {
        state.isServerOut = isServerOut
    },
    SET_CONFIG(state, config) {

        if(config.language){
            localStorage.lang = config.language
        }

        state.config = config
    },
    SET_UNIDADE(state, id) {
        state.unidadeId = id;
        localStorage.unidadePadraoId = id;
    },
    CLEAR_ERRO(state) {
        state.erros = [];
    },
    ADD_ERRO(state, erro) {
        state.erros.push(erro);
    }, 
    SET_AGENDAMENTOTAREFACONFIG(state, config) {
        state.agendamentoTarefaConfiguracoes = config;
    }, 
    CLEAR_ABRIRGUIA(state) {
        state.usuario.abrirGuiaId = ''; 
        state.usuario.abrirUnidadeId = '';
        state.usuario.abrirCodigoLote = '';
        state.usuario.abrirAssistenciaId = '';
    },                        
    SET_AUTH(state, auth) {
        state.usuario.nome = auth.usuario;
        state.usuario.nomeCadastro = auth.nomeCadastro;
        state.usuario.apelido = auth.apelido;
        state.usuario.id = auth.id; 
        state.usuario.funcionarioId = auth.funcionarioId;
        state.usuario.funcionarioNome = auth.funcionarioNome;
        state.usuario.nivel = auth.nivel;
        state.usuario.administrador = auth.administrador;
        state.usuario.bloquearacessoatrasos = auth.bloquearacessoatrasos;
        state.usuario.quantidadeatrasos = auth.quantidadeatrasos;
        state.usuario.unidadeId = auth.unidadeId;        
        state.usuario.tipos = auth.tipos;               
        state.usuario.regras = auth.regras; 
        state.usuario.abrirGuiaId = auth.abrirGuiaId; 
        state.usuario.abrirUnidadeId = auth.abrirUnidadeId;
        state.usuario.abrirCodigoLote = auth.abrirCodigoLote;
        state.usuario.abrirAssistenciaId = auth.abrirAssistenciaId;
        state.usuario.discordUserId = auth.discordUserId; 
        state.usuario.tipo = auth.tipo; 
        state.isAuthenticated = (auth.usuario !== undefined && auth.usuario !== '');

        if (state.isAuthenticated) {

            if (state.cidades.length == 0) {
                http.get('/api/auth/cidades')
                    .then(res => {
                        state.cidades = res.data;
                        state.estados = Array.from(new Set(state.cidades?.map(c => c.estado)?.sort()));
                    })
            }

            http.get('/api/auth/unidades?funcionarioId=' + state.usuario.funcionarioId)
                .then(res => {
                    state.unidades = res.data
                    if(state.usuario.unidadeId !=null && state.usuario.unidadeId >0){
                        state.unidadeId =state.usuario.unidadeId
                        localStorage.unidadePadraoId = state.usuario.unidadeId
                    }else  if (localStorage.unidadePadraoId == -1) {
                        state.unidadeId = res.data[0].id
                        localStorage.unidadePadraoId = res.data[0].id
                    }
                })

            if (state.config.logoffTimer) {
                startIdle();
            }            
        } else {
            if (state.config.logoffTimer) {
                stopIdle();
            }            
        }
    },
}

export function createVue2Store() {
    const vuexLocal = new VuexPersistence<RootState>({
        storage: window.localStorage,
        modules: ['componentes']
    })

    return new Vuex.Store({
        state: createRootState(),
        actions: rootActions,
        getters: rootGetters,
        mutations: rootMutations,
        modules: {
            componentes
        },
        plugins: [vuexLocal.plugin]
    })
}
